import React from 'react';
import { Button as MUIButton } from '@material-ui/core';

const Button = props => {
    const { children, icon, style, ...rest } = props;

    return (
        <MUIButton
            startIcon={<i className="material-icons">{icon}</i>}
            style={style ?  style : {
                marginLeft: 2,
                marginRight: 2
            }}
            {...rest}
        >
            {children}
        </MUIButton>
    );
};

export default Button;